import { render, staticRenderFns } from "./NiceBtn.vue?vue&type=template&id=59702326&scoped=true"
import script from "./NiceBtn.vue?vue&type=script&lang=js"
export * from "./NiceBtn.vue?vue&type=script&lang=js"
import style0 from "./NiceBtn.vue?vue&type=style&index=0&id=59702326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59702326",
  null
  
)

export default component.exports